import { render, staticRenderFns } from "./StudentHabitGoalsDialog.vue?vue&type=template&id=5b204ace&scoped=true"
import script from "./StudentHabitGoalsDialog.vue?vue&type=script&lang=js"
export * from "./StudentHabitGoalsDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentHabitGoalsDialog.vue?vue&type=style&index=0&id=5b204ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b204ace",
  null
  
)

export default component.exports